module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel-add",
    attrs: {
      "datas": _vm.options
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Instance Detail")])], 1), _vm._v(" "), _c('div', {
    staticClass: "cloud-wrapper",
    slot: "content"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.baseInfo,
      "name": "baseInfo"
    }
  }, [(!_vm.basicInfo.show) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.basicInfo.show),
      expression: "!basicInfo.show"
    }],
    staticStyle: {
      "height": "300px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.basicInfo.show) ? _c('div', [_c('div', {
    staticClass: "info-content"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_c('translate', [_vm._v("Information")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Instance ID")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.options.instanceId))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Instance Name")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.InstanceName))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Zone")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.ZoneName))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Region")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.RegionName))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_c('translate', [_vm._v("Configuration Information")])], 1), _vm._v(" "), _c('ul', [_c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("CPU")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.Cpu) + "  core")]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("RAM")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Memory))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Public Network IP")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err && _vm.basicInfo.Instances.InstanceNetworkType == 'vpc') ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.EipAddress.IpAddress))]) : _vm._e(), _vm._v(" "), (!_vm.basicInfo.err && _vm.basicInfo.Instances.InstanceNetworkType != 'vpc') ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.PublicIpAddress.IpAddress.join(',')))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Intranet IP")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err && _vm.basicInfo.Instances.InstanceNetworkType == 'vpc') ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.VpcAttributes.PrivateIpAddress.IpAddress[0]))]) : _vm._e(), _vm._v(" "), (!_vm.basicInfo.err && _vm.basicInfo.Instances.InstanceNetworkType != 'vpc') ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(_vm.basicInfo.Instances.InnerIpAddress.IpAddress.join(',')))]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("System Disk")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    attrs: {
      "span": 17
    }
  }, [_vm._v(_vm._s(((_vm.diskCategory[_vm.basicInfo.systemDisk.Category]) + " " + (_vm.basicInfo.systemDisk.Size) + "GB")) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('li', [_c('el-col', {
    staticClass: "info-name",
    attrs: {
      "span": 7
    }
  }, [_c('translate', [_vm._v("Data Disk")]), _vm._v("\n                  :\n                ")], 1), _vm._v(" "), (!_vm.basicInfo.err) ? _c('el-col', {
    staticClass: "ak-defined",
    attrs: {
      "span": 17
    }
  }, [(_vm.basicInfo.systemDisk.DiskId && (!_vm.basicInfo.dataDisk || _vm.basicInfo.dataDisk.length == 0)) ? _c('div', [_vm._v(" - ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.basicInfo.dataDisk), function(disk, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(disk.category ? ((_vm.diskCategory[disk.category]) + " " + (disk.size) + "GB") : '-'))])
  })], 2) : _vm._e()], 1)])])]) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.attrText.monitorInfo,
      "name": "monitorInfo"
    }
  }, [_c('div', {
    staticClass: "select-time"
  }, [_c('el-select', {
    on: {
      "change": _vm.onSelectTime
    },
    model: {
      value: (_vm.monitorInfo.selectTime),
      callback: function($$v) {
        _vm.monitorInfo.selectTime = $$v
      },
      expression: "monitorInfo.selectTime"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.attrText.onehour,
      "value": "oneHour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.sixhour,
      "value": "sixHour"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.oneday,
      "value": "oneDay"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.attrText.sevenday,
      "value": "sevenDay"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.monitorInfo.show) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.monitorInfo.show),
      expression: "!monitorInfo.show"
    }],
    staticStyle: {
      "height": "300px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.monitorInfo.show && _vm.monitorInfo.err) ? _c('div', {
    staticStyle: {
      "line-height": "100px",
      "text-align": "center"
    }
  }, [_c('translate', [_vm._v("No Monitoring Information Is Available")])], 1) : _vm._e(), _vm._v(" "), (_vm.monitorInfo.show && !_vm.monitorInfo.err) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.monitorInfo.show),
      expression: "!monitorInfo.show"
    }],
    staticClass: "show-chart"
  }, [_c('div', {
    staticClass: "chart-item"
  }, [_c('h3', {
    staticClass: "chart-title"
  }, [_c('translate', [_vm._v("CPU Monitoring")])], 1), _vm._v(" "), (_vm.monitorInfo.cpuData) ? _c('nvd3-line-chart', {
    attrs: {
      "options": _vm.monitorInfo.cpuData.options,
      "data": _vm.monitorInfo.cpuData.data
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-item"
  }, [_c('h3', {
    staticClass: "chart-title"
  }, [_c('translate', [_vm._v("Network Monitoring")])], 1), _vm._v(" "), (_vm.monitorInfo.netData) ? _c('nvd3-line-chart', {
    attrs: {
      "options": _vm.monitorInfo.netData.options,
      "data": _vm.monitorInfo.netData.data
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-item"
  }, [_c('h3', {
    staticClass: "chart-title"
  }, [_c('translate', [_vm._v("Disk Monitoring")])], 1), _vm._v(" "), (_vm.monitorInfo.diskData) ? _c('nvd3-line-chart', {
    attrs: {
      "options": _vm.monitorInfo.diskData.options,
      "data": _vm.monitorInfo.diskData.data
    }
  }) : _vm._e()], 1)]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.basicInfo.err || _vm.basicInfo.Instances.Status === 'Running' || _vm.basicInfo.Instances.Status === 'Stopping' || _vm.basicInfo.Instances.Status === 'Starting'
    },
    on: {
      "click": function($event) {
        _vm.onShowDialog(1)
      }
    }
  }, [_c('translate', [_vm._v("Start")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "disabled": _vm.basicInfo.err || _vm.basicInfo.Instances.Status === 'Stopped' || _vm.basicInfo.Instances.Status === 'Stopping' || _vm.basicInfo.Instances.Status === 'Starting'
    },
    on: {
      "click": function($event) {
        _vm.onShowDialog(2)
      }
    }
  }, [_c('translate', [_vm._v("Reboot")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.basicInfo.err || _vm.basicInfo.Instances.Status !== 'Running' || _vm.basicInfo.Instances.Status === 'Starting' || _vm.basicInfo.Instances.Status === 'Stopping'
    },
    on: {
      "click": function($event) {
        _vm.onShowDialog(3)
      }
    }
  }, [_c('translate', [_vm._v("Stop")])], 1), _vm._v(" "), (_vm.basicInfo.Instances.Status !== 'Running' && _vm.basicInfo.Instances.Status !== 'Stopped') ? _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "color": "red"
    }
  }, [(_vm.basicInfo.Instances.Status === 'Stopping') ? _c('translate', [_vm._v("The Instance Is Stopping")]) : _vm._e(), _vm._v(" "), (_vm.basicInfo.Instances.Status === 'Starting') ? _c('translate', [_vm._v("The Instance Is Starting Up")]) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18f2b4c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/cluster-cloud-ak.vue
// module id = 532
// module chunks = 4 5 6